import { useState, useEffect, useRef, useCallback } from "react";
import {
  fetchTodasOS, fetchOSporChave, fetchOSporSolicitante, criarOS, reenviarOS,
  editarOS, deletarOS, aceitarOS, devolverOS,
  iniciarOS, paralisarOS, finalizarOS, downloadAnexo,
  fetchUsuarios, salvarUsuario, deletarUsuario,
  calcularPrazoEstimado, fetchConfiguracoes, salvarConfiguracao,
} from "./api";

// ─── PDF ──────────────────────────────────────────────────────────────────────
function gerarPDF(os) {
  const prio = { normal:"Normal", alta:"Alta", urgente:"URGENTE" };
  const status = { pendente:"Aguardando Aprovação", correcao:"Em Correção", aguardando:"Na Fila",
    paralisado:"Paralisado", execucao:"Em Execução", finalizado:"Finalizado", cancelado:"Cancelado" };

  const historico = os.historico.map(h =>
    `<tr>
      <td style="padding:6px 10px;border-bottom:1px solid #E2E8F0;font-size:12px;">${h.data}</td>
      <td style="padding:6px 10px;border-bottom:1px solid #E2E8F0;font-size:12px;">${h.acao}</td>
      <td style="padding:6px 10px;border-bottom:1px solid #E2E8F0;font-size:12px;">${h.usuario}</td>
      <td style="padding:6px 10px;border-bottom:1px solid #E2E8F0;font-size:12px;color:#DC2626;">${h.obs||""}</td>
    </tr>`
  ).join("");

  const anexos = os.anexos.length > 0
    ? os.anexos.map(a => `<li style="font-size:12px;margin:3px 0;">${a.nome}</li>`).join("")
    : "<li style='font-size:12px;color:#94A3B8;'>Nenhum anexo</li>";

  const html = `<!DOCTYPE html><html lang="pt-BR">
<head><meta charset="UTF-8"><title>${os.id}</title>
<style>
  body{font-family:'Segoe UI',Arial,sans-serif;color:#0F172A;margin:0;padding:32px;}
  h1{font-size:26px;font-weight:800;margin:0 0 4px;}
  .header{background:#0F172A;color:white;padding:20px 28px;border-radius:10px;margin-bottom:24px;display:flex;justify-content:space-between;align-items:center;}
  .header-brand{font-size:18px;font-weight:800;}
  .header-sub{font-size:10px;color:#475569;letter-spacing:2px;text-transform:uppercase;margin-top:2px;}
  .section{margin-bottom:20px;}
  .section-title{font-size:10px;font-weight:700;color:#94A3B8;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px;}
  .grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:16px;}
  .field-label{font-size:10px;font-weight:700;color:#94A3B8;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:2px;}
  .field-value{font-size:14px;font-weight:600;color:#0F172A;}
  .desc-box{background:#F8FAFC;border:1px solid #E2E8F0;border-radius:8px;padding:14px;font-size:13px;line-height:1.7;margin-bottom:16px;}
  .badge{display:inline-block;padding:3px 12px;border-radius:99px;font-size:11px;font-weight:700;}
  table{width:100%;border-collapse:collapse;}
  th{background:#F8FAFC;padding:8px 10px;text-align:left;font-size:11px;font-weight:700;color:#64748B;border-bottom:1.5px solid #E2E8F0;}
  .exec-box{background:linear-gradient(135deg,#4F46E5,#7C3AED);color:white;border-radius:10px;padding:14px 18px;margin-bottom:16px;display:flex;align-items:center;gap:14px;}
  .exec-name{font-size:18px;font-weight:800;}
  .exec-label{font-size:9px;color:rgba(255,255,255,0.7);text-transform:uppercase;letter-spacing:1px;}
  .footer{margin-top:32px;padding-top:16px;border-top:1px solid #E2E8F0;font-size:11px;color:#94A3B8;text-align:center;}
  @media print{body{padding:16px;}button{display:none!important;}}
</style></head>
<body>
<div class="header">
  <div><div class="header-brand">⚙️ LabOS</div><div class="header-sub">Laboratório de Usinagem</div></div>
  <div style="text-align:right;">
    <div style="font-size:20px;font-weight:800;font-family:monospace;">${os.id}</div>
    <div style="font-size:11px;color:#94A3B8;margin-top:2px;">Emitido em ${new Date().toLocaleString("pt-BR")}</div>
  </div>
</div>

${os.executante ? `
<div class="exec-box">
  <div style="font-size:28px;">👷</div>
  <div><div class="exec-label">Executante</div><div class="exec-name">${os.executante}</div></div>
</div>` : ""}

<div class="section">
  <div class="section-title">Status e Prioridade</div>
  <div style="display:flex;gap:10px;align-items:center;">
    <span class="badge" style="background:#EDE9FE;color:#7C3AED;">${status[os.status]||os.status}</span>
    <span class="badge" style="background:#FEF3C7;color:#D97706;">${prio[os.prioridade]||os.prioridade}</span>
  </div>
</div>

<div class="section">
  <div class="section-title">Dados do Solicitante</div>
  <div class="grid">
    <div><div class="field-label">Solicitante</div><div class="field-value">${os.solicitante.nome}</div></div>
    <div><div class="field-label">Projeto / Disciplina</div><div class="field-value">${os.solicitante.setor}</div></div>
    <div><div class="field-label">E-mail</div><div class="field-value">${os.solicitante.email}</div></div>
    <div><div class="field-label">Telefone</div><div class="field-value">${os.solicitante.telefone||"—"}</div></div>
  </div>
</div>

<div class="section">
  <div class="section-title">Dados do Serviço</div>
  <div class="grid">
    <div><div class="field-label">Serviço</div><div class="field-value">${os.servico}</div></div>
    <div><div class="field-label">Prazo</div><div class="field-value">${os.prazo}</div></div>
    <div><div class="field-label">Criado em</div><div class="field-value">${os.dataCriacao}</div></div>
    ${os.coordenador ? `<div><div class="field-label">Gestor resp.</div><div class="field-value">${os.coordenador}</div></div>` : ""}
  </div>
  <div class="section-title">Descrição</div>
  <div class="desc-box">${os.descricao}</div>
</div>

<div class="section">
  <div class="section-title">Anexos</div>
  <ul style="margin:0;padding-left:18px;">${anexos}</ul>
</div>

<div class="section">
  <div class="section-title">Histórico</div>
  <table>
    <thead><tr>
      <th>Data</th><th>Ação</th><th>Usuário</th><th>Observação</th>
    </tr></thead>
    <tbody>${historico}</tbody>
  </table>
</div>

<div class="footer">LabOS — Laboratório de Usinagem · UNIFEI Campus Itabira · Documento gerado automaticamente<br/>Desenvolvido por Nayara Reis — UNIFEI 2026</div>
<br/>
<div style="text-align:center;">
  <button onclick="window.print()" style="background:#4F46E5;color:white;border:none;border-radius:8px;padding:10px 28px;font-size:13px;font-weight:700;cursor:pointer;">🖨️ Imprimir / Salvar PDF</button>
</div>
</body></html>`;

  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (w) w.onload = () => URL.revokeObjectURL(url);
}

// ─── CONSTANTES ───────────────────────────────────────────────────────────────
const SERVICOS = [
  "Torneamento CNC","Centro de Usinagem","Fresamento","serra de fita",
  "Torneamento","Torneamento + Fresamento","Eletroerosão a fio",
  "Furação ","Rosqueamento","Outro",
];

const STATUS_MAP = {
  pendente:   { label:"Aguard. Aprovação", color:"#D97706", bg:"#FEF3C7", icon:"⏳" },
  correcao:   { label:"Em Correção",       color:"#DC2626", bg:"#FEE2E2", icon:"↩️" },
  aguardando: { label:"Na Fila",           color:"#2563EB", bg:"#DBEAFE", icon:"📋" },
  paralisado: { label:"Paralisado",        color:"#EA580C", bg:"#FFF7ED", icon:"⏸️" },
  execucao:   { label:"Em Execução",       color:"#7C3AED", bg:"#EDE9FE", icon:"⚙️" },
  finalizado: { label:"Finalizado",        color:"#059669", bg:"#D1FAE5", icon:"✅" },
  cancelado:  { label:"Cancelado",         color:"#6B7280", bg:"#F3F4F6", icon:"❌" },
};
const PRIO_MAP = {
  normal:  { label:"Normal",    color:"#6B7280", dot:"#9CA3AF" },
  alta:    { label:"Alta",      color:"#D97706", dot:"#FBBF24" },
  urgente: { label:"URGENTE",   color:"#DC2626", dot:"#F87171" },
};

// ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
const C = {
  bg: "#F0F2F5",
  surface: "#FFFFFF",
  border: "#E2E8F0",
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  indigo: "#4F46E5",
  indigoHover: "#4338CA",
  indigoLight: "#EEF2FF",
};

// ─── ATOMS ────────────────────────────────────────────────────────────────────
function Badge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.pendente;
  return (
    <span style={{ background: s.bg, color: s.color, border: `1px solid ${s.color}35`,
      padding: "3px 11px", borderRadius: 99, fontSize: 11, fontWeight: 700,
      letterSpacing: 0.2, whiteSpace: "nowrap", display:"inline-flex", alignItems:"center", gap:4 }}>
      {s.icon} {s.label}
    </span>
  );
}

function PrioBadge({ p }) {
  const pr = PRIO_MAP[p] || PRIO_MAP.normal;
  return (
    <span style={{ color: pr.color, fontSize: 11, fontWeight: 700,
      display:"inline-flex", alignItems:"center", gap:5 }}>
      <span style={{ width:7, height:7, borderRadius:"50%", background:pr.dot, display:"inline-block" }}/>
      {p === "urgente" ? "🔴 " : ""}{pr.label}
    </span>
  );
}

function FileIcon({ name }) {
  const ext = (name||"").split(".").pop().toLowerCase();
  const m = { pdf:"📄", dwg:"📐", sldprt:"🔩", step:"🔩", stp:"🔩", docx:"📝", doc:"📝", xlsx:"📊" };
  return <span>{m[ext]||"📎"}</span>;
}

function Spinner() {
  return (
    <div style={{ display:"flex", justifyContent:"center", alignItems:"center", padding:60 }}>
      <div style={{ width:36, height:36, border:"3px solid #E2E8F0",
        borderTop:`3px solid ${C.indigo}`, borderRadius:"50%", animation:"spin .8s linear infinite" }}/>
    </div>
  );
}

function Toast({ msg, tipo, onClose }) {
  const map = { success:["#059669","#D1FAE5","✅"], error:["#DC2626","#FEE2E2","❌"], warn:["#D97706","#FEF3C7","⚠️"], info:["#2563EB","#DBEAFE","ℹ️"] };
  const [c, bg, icon] = map[tipo]||map.info;
  return (
    <div style={{ position:"fixed", top:20, right:20, left:20, zIndex:9999, background:bg,
      border:`1.5px solid ${c}`, borderRadius:12, padding:"14px 18px",
      maxWidth:360, margin:"0 auto",
      boxShadow:"0 8px 30px rgba(0,0,0,0.13)", display:"flex", gap:10, alignItems:"flex-start",
      animation:"slideIn .3s ease" }}>
      <span style={{ fontSize:18 }}>{icon}</span>
      <div style={{ flex:1, fontSize:13, color:C.textPrimary, lineHeight:1.5 }}>{msg}</div>
      <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", color:c, fontSize:18, lineHeight:1, padding:0 }}>×</button>
    </div>
  );
}

function Modal({ children, onClose, width=620 }) {
  const isMobile = useIsMobile();
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.55)", zIndex:1000,
      display:"flex", alignItems: isMobile ? "flex-end" : "center",
      justifyContent:"center", padding: isMobile ? 0 : 20 }}
      onClick={onClose}>
      <div style={{ background:C.surface, borderRadius: isMobile ? "18px 18px 0 0" : 18,
        width:"100%", maxWidth: isMobile ? "100%" : width,
        maxHeight: isMobile ? "95vh" : "92vh", overflow:"auto",
        boxShadow:"0 24px 80px rgba(0,0,0,0.25)" }}
        onClick={e=>e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

function Confirm({ msg, onConfirm, onCancel }) {
  return (
    <Modal onClose={onCancel} width={420}>
      <div style={{ padding:"32px 28px", textAlign:"center" }}>
        <div style={{ fontSize:42, marginBottom:12 }}>⚠️</div>
        <p style={{ fontSize:15, color:C.textPrimary, marginBottom:28, lineHeight:1.6 }}>{msg}</p>
        <div style={{ display:"flex", gap:10, justifyContent:"center" }}>
          <Btn color="#DC2626" onClick={onConfirm}>Confirmar</Btn>
          <Btn color={C.textSecondary} onClick={onCancel}>Cancelar</Btn>
        </div>
      </div>
    </Modal>
  );
}

function Btn({ children, onClick, color=C.indigo, outline=false, size="md", disabled=false }) {
  const pad = size === "sm" ? "6px 14px" : size === "lg" ? "14px 32px" : "9px 20px";
  const fs  = size === "sm" ? 12 : size === "lg" ? 15 : 13;
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background: outline ? "white" : disabled ? "#CBD5E1" : color,
      color: outline ? color : "white",
      border: outline ? `2px solid ${color}` : "none",
      borderRadius: 10, padding: pad, fontWeight: 700, fontSize: fs,
      cursor: disabled ? "not-allowed" : "pointer", fontFamily:"inherit",
      transition:"opacity .15s", whiteSpace:"nowrap",
    }}
      onMouseEnter={e=>{ if(!disabled) e.currentTarget.style.opacity=".85"; }}
      onMouseLeave={e=>{ e.currentTarget.style.opacity="1"; }}>
      {children}
    </button>
  );
}

function Input({ label, value, onChange, placeholder, type="text", required }) {
  return (
    <div>
      <label style={{ fontSize:12, fontWeight:700, color:C.textSecondary, display:"block", marginBottom:5 }}>
        {label}{required && <span style={{ color:"#DC2626" }}> *</span>}
      </label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:"100%", padding:"9px 12px", borderRadius:9, border:`1.5px solid ${C.border}`,
          fontSize:14, outline:"none", boxSizing:"border-box", fontFamily:"inherit" }}/>
    </div>
  );
}

function Select({ label, value, onChange, options, required }) {
  return (
    <div>
      <label style={{ fontSize:12, fontWeight:700, color:C.textSecondary, display:"block", marginBottom:5 }}>
        {label}{required && <span style={{ color:"#DC2626" }}> *</span>}
      </label>
      <select value={value} onChange={e=>onChange(e.target.value)}
        style={{ width:"100%", padding:"9px 12px", borderRadius:9, border:`1.5px solid ${C.border}`,
          fontSize:14, outline:"none", boxSizing:"border-box", background:"white", fontFamily:"inherit" }}>
        <option value="">Selecione...</option>
        {options.map(o=><option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

function Card({ children, style }) {
  return (
    <div style={{ background:C.surface, border:`1.5px solid ${C.border}`,
      borderRadius:14, padding:"20px 22px", ...style }}>
      {children}
    </div>
  );
}

// ─── HOOK RESPONSIVO ─────────────────────────────────────────────────────────
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

function SectionTitle({ children }) {
  return <div style={{ fontSize:12, fontWeight:800, color:C.textSecondary,
    textTransform:"uppercase", letterSpacing:1, marginBottom:14 }}>{children}</div>;
}

function Grid({ cols=2, children }) {
  const isMobile = useIsMobile();
  return (
    <div style={{ display:"grid", gridTemplateColumns: isMobile ? "1fr" : `repeat(${cols},1fr)`, gap:12 }}>
      {children}
    </div>
  );
}

// ─── DETALHE OS ───────────────────────────────────────────────────────────────
function DetalheOS({ os, onClose, extra, ocultarContato=false }) {
  // Busca o último motivo de paralisação no histórico
  const motivoParalisacao = os.historico
    .filter(h => h.acao === "Execução paralisada")
    .slice(-1)[0]?.obs || null;

  return (
    <Modal onClose={onClose} width={660}>
      <div style={{ padding:"28px 28px" }}>
        {/* Header */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:22 }}>
          <div>
            <div style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:800, color:C.textPrimary }}>{os.id}</div>
            <div style={{ display:"flex", gap:8, marginTop:8, flexWrap:"wrap" }}>
              <Badge status={os.status}/><PrioBadge p={os.prioridade}/>
            </div>
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <Btn size="sm" outline color={C.indigo} onClick={()=>gerarPDF(os)}>📄 PDF</Btn>
            <button onClick={onClose} style={{ background:"none", border:"none", fontSize:24, cursor:"pointer", color:C.textSecondary, lineHeight:1 }}>×</button>
          </div>
        </div>

        {/* Executante em destaque */}
        {os.executante && (
          <div style={{ background:"linear-gradient(135deg,#4F46E5,#7C3AED)", borderRadius:12,
            padding:"14px 18px", marginBottom:18, display:"flex", alignItems:"center", gap:14 }}>
            <div style={{ fontSize:32 }}>👷</div>
            <div>
              <div style={{ fontSize:10, color:"rgba(255,255,255,0.7)", fontWeight:700, textTransform:"uppercase", letterSpacing:1 }}>Executante</div>
              <div style={{ fontFamily:"'Syne',sans-serif", fontSize:20, fontWeight:800, color:"white" }}>{os.executante}</div>
            </div>
          </div>
        )}

        {/* Alerta de paralisação — visível para todos */}
        {os.status === "paralisado" && motivoParalisacao && (
          <div style={{ background:"#FFF7ED", border:"1.5px solid #FED7AA", borderRadius:10,
            padding:"12px 16px", marginBottom:16, display:"flex", gap:10, alignItems:"flex-start" }}>
            <span style={{ fontSize:18 }}>⏸️</span>
            <div>
              <div style={{ fontSize:11, fontWeight:700, color:"#EA580C", marginBottom:3 }}>EXECUÇÃO PARALISADA</div>
              <div style={{ fontSize:13, color:"#9A3412" }}>{motivoParalisacao}</div>
            </div>
          </div>
        )}

        <Grid cols={2}>
          <InfoItem label="Solicitante" value={os.solicitante.nome}/>
          <InfoItem label="Projeto / Disciplina" value={os.solicitante.setor}/>
          {!ocultarContato && <InfoItem label="E-mail" value={os.solicitante.email}/>}
          {!ocultarContato && <InfoItem label="Telefone" value={os.solicitante.telefone}/>}
          <InfoItem label="Serviço" value={os.servico}/>
          <InfoItem label="Quantidade" value={os.quantidade ? `${os.quantidade} peça${os.quantidade > 1 ? 's' : ''}` : '1 peça'}/>
          <InfoItem label="Prazo" value={os.prazo}/>
          {os.coordenador && <InfoItem label="Gestor resp." value={os.coordenador}/>}
          <InfoItem label="Criado em" value={os.dataCriacao}/>
        </Grid>

        <div style={{ background:"#F8FAFC", borderRadius:10, padding:"12px 14px", margin:"16px 0" }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.textSecondary, marginBottom:4 }}>DESCRIÇÃO</div>
          <div style={{ fontSize:13, color:C.textPrimary, lineHeight:1.7 }}>{os.descricao}</div>
        </div>

        {os.observacaoCoord && (
          <div style={{ background:"#FEF3C7", borderRadius:10, padding:"12px 14px", marginBottom:14, border:"1px solid #FDE68A" }}>
            <div style={{ fontSize:11, fontWeight:700, color:"#92400E", marginBottom:4 }}>OBSERVAÇÃO DO GESTOR</div>
            <div style={{ fontSize:13, color:"#78350F" }}>{os.observacaoCoord}</div>
          </div>
        )}

        {os.justificativaUrgente && (
          <div style={{ background:"#FEF2F2", borderRadius:10, padding:"12px 14px", marginBottom:14, border:"1.5px solid #FCA5A5" }}>
            <div style={{ fontSize:11, fontWeight:700, color:"#DC2626", marginBottom:4 }}>🔴 JUSTIFICATIVA — PRIORIDADE URGENTE</div>
            <div style={{ fontSize:13, color:"#7F1D1D" }}>{os.justificativaUrgente}</div>
          </div>
        )}

        {os.anexos.length > 0 && (
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:11, fontWeight:700, color:C.textSecondary, marginBottom:8 }}>ANEXOS ({os.anexos.length})</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
              {os.anexos.map((a,i)=>(
                <button key={i} onClick={()=>downloadAnexo(a.path,a.nome)}
                  style={{ display:"flex", alignItems:"center", gap:6, background:"#F1F5F9",
                    border:"1px solid #E2E8F0", borderRadius:8, padding:"6px 12px", fontSize:12, cursor:"pointer" }}>
                  <FileIcon name={a.nome}/>{a.nome} ⬇️
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Histórico */}
        <div style={{ fontSize:11, fontWeight:700, color:C.textSecondary, marginBottom:10 }}>HISTÓRICO</div>
        <div style={{ position:"relative", paddingLeft:22 }}>
          <div style={{ position:"absolute", left:8, top:0, bottom:0, width:2, background:"#E2E8F0" }}/>
          {os.historico.map((h,i)=>(
            <div key={i} style={{ position:"relative", marginBottom:14, paddingLeft:10 }}>
              <div style={{ position:"absolute", left:-15, top:4, width:10, height:10,
                borderRadius:"50%", background:C.indigo, border:"2px solid white",
                boxShadow:`0 0 0 2px ${C.indigo}` }}/>
              <div style={{ fontSize:13, fontWeight:700, color:C.textPrimary }}>{h.acao}</div>
              <div style={{ fontSize:11, color:C.textSecondary }}>{h.data} — {h.usuario}</div>
              {h.obs && <div style={{ fontSize:12, color:"#EA580C", marginTop:2 }}>↳ {h.obs}</div>}
            </div>
          ))}
        </div>

        {extra && <div style={{ marginTop:16, paddingTop:16, borderTop:`1px solid ${C.border}` }}>{extra}</div>}
      </div>
    </Modal>
  );
}

function InfoItem({ label, value }) {
  return (
    <div>
      <div style={{ fontSize:10, fontWeight:700, color:"#94A3B8", textTransform:"uppercase", letterSpacing:0.6, marginBottom:2 }}>{label}</div>
      <div style={{ fontSize:14, color:C.textPrimary, fontWeight:600 }}>{value||"—"}</div>
    </div>
  );
}

// ─── FORMULÁRIO OS (reutilizado em Nova OS + Editar) ──────────────────────────
function FormOS({ inicial, onSubmit, onCancel, loading, titulo, osCorrecting }) {
  const [form, setForm] = useState(inicial || {
    nome:"", email:"", setor:"", telefone:"",
    descricao:"", servico:"", prioridade:"normal", prazo:"",
    quantidade:1, justificativa_urgente:"", arquivos:[],
  });
  const [drag, setDrag] = useState(false);
  const [prazoModal, setPrazoModal] = useState(null); // { data, dataISO }
  const [loadingPrazo, setLoadingPrazo] = useState(false);
  const fileRef = useRef();
  const s = (k,v) => setForm(f=>({...f,[k]:v}));

  const handleFiles = files => s("arquivos",[...form.arquivos,...Array.from(files)]);

  // Quando serviço é selecionado, calcula prazo e abre modal
  const handleServicoChange = async (servico) => {
    s("servico", servico);
    s("prazo", ""); // limpa prazo anterior
    if (!servico) return;
    setLoadingPrazo(true);
    try {
      const resultado = await calcularPrazoEstimado(servico);
      setPrazoModal(resultado);
    } catch(e) {
      console.warn("Erro ao calcular prazo:", e.message);
    } finally {
      setLoadingPrazo(false);
    }
  };

  const confirmarPrazo = () => {
    s("prazo", prazoModal.dataISO);
    setPrazoModal(null);
  };

  const cancelarPrazo = () => {
    s("servico", "");
    s("prazo", "");
    setPrazoModal(null);
  };

  const submit = () => {
    if (!form.nome||!form.email||!form.descricao||!form.servico) {
      alert("Preencha todos os campos obrigatórios (*).");
      return;
    }
    if (!form.prazo) {
      alert("Selecione o tipo de serviço para calcular o prazo.");
      return;
    }
    if (form.prioridade==="urgente" && !form.justificativa_urgente.trim()) {
      alert("É obrigatório informar a justificativa para prioridade URGENTE.");
      return;
    }
    onSubmit(form);
  };

  return (
    <div style={{ padding:"28px 28px" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <div>
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:800, color:C.textPrimary }}>{titulo}</div>
          {osCorrecting && (
            <div style={{ marginTop:8, background:"#FEF3C7", border:"1px solid #FDE68A",
              borderRadius:8, padding:"9px 14px", fontSize:13, color:"#92400E" }}>
              <strong>Motivo da devolução:</strong> {osCorrecting.observacaoCoord}
            </div>
          )}
        </div>
        {onCancel && <button onClick={onCancel} style={{ background:"none", border:"none", fontSize:24, cursor:"pointer", color:C.textSecondary }}>×</button>}
      </div>

      <div style={{ marginBottom:20 }}>
        <SectionTitle>👤 Dados do Solicitante</SectionTitle>
        <Grid cols={2}>
          <Input label="Nome completo" value={form.nome} onChange={v=>s("nome",v)} placeholder="João da Silva" required/>
          <Input label="E-mail" value={form.email} onChange={v=>s("email",v)} placeholder="joao@empresa.com" type="email" required/>
          <Input label="Telefone / Ramal" value={form.telefone} onChange={v=>s("telefone",v)} placeholder="31 9xxxx-xxxx"/>
          <Input label="Projeto / Disciplina" value={form.setor} onChange={v=>s("setor",v)} placeholder="Ex: TCC, Iniciação Científica, Mecânica dos Sólidos..." required/>
        </Grid>
      </div>

      <div style={{ marginBottom:20 }}>
        <SectionTitle>🔧 Dados do Serviço</SectionTitle>
        <Grid cols={2}>
          <div>
            <Select label="Tipo de serviço" value={form.servico}
              onChange={handleServicoChange} options={SERVICOS} required/>
            {loadingPrazo && (
              <div style={{ fontSize:11, color:C.indigo, marginTop:4 }}>⏳ Calculando prazo...</div>
            )}
            {form.prazo && (
              <div style={{ fontSize:11, color:"#059669", marginTop:4, fontWeight:700 }}>
                📅 Prazo estimado: {new Date(form.prazo+'T12:00:00').toLocaleDateString('pt-BR')}
              </div>
            )}
          </div>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:C.textSecondary, display:"block", marginBottom:5 }}>
              Quantidade de peças <span style={{ color:"#DC2626" }}>*</span>
            </label>
            <div style={{ display:"flex", alignItems:"center", gap:0, border:`1.5px solid ${C.border}`,
              borderRadius:9, overflow:"hidden", background:"white" }}>
              <button type="button"
                onClick={()=>s("quantidade", Math.max(1, (form.quantidade||1) - 1))}
                style={{ width:44, height:42, background:"#F8FAFC", border:"none",
                  borderRight:`1px solid ${C.border}`, fontSize:20, cursor:"pointer",
                  color:C.textPrimary, fontWeight:700, flexShrink:0 }}>−</button>
              <input
                type="number"
                inputMode="numeric"
                min="1"
                value={form.quantidade||1}
                onChange={e=>s("quantidade", parseInt(e.target.value)||1)}
                style={{ flex:1, padding:"9px 4px", fontSize:16, fontWeight:700,
                  textAlign:"center", border:"none", outline:"none",
                  fontFamily:"inherit", background:"white" }}/>
              <button type="button"
                onClick={()=>s("quantidade", (form.quantidade||1) + 1)}
                style={{ width:44, height:42, background:"#F8FAFC", border:"none",
                  borderLeft:`1px solid ${C.border}`, fontSize:20, cursor:"pointer",
                  color:C.textPrimary, fontWeight:700, flexShrink:0 }}>+</button>
            </div>
          </div>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:C.textSecondary, display:"block", marginBottom:5 }}>Prioridade</label>
            <div style={{ display:"flex", gap:8 }}>
              {["normal","alta","urgente"].map(p=>(
                <button key={p} onClick={()=>s("prioridade",p)} style={{
                  flex:1, padding:"8px 0", borderRadius:8, border:"2px solid",
                  borderColor: form.prioridade===p ? PRIO_MAP[p].dot : C.border,
                  background: form.prioridade===p ? PRIO_MAP[p].dot+"20" : "white",
                  color: form.prioridade===p ? PRIO_MAP[p].color : C.textSecondary,
                  fontWeight:700, fontSize:12, cursor:"pointer",
                }}>{PRIO_MAP[p].label}</button>
              ))}
            </div>
          </div>
        </Grid>

        {/* Justificativa obrigatória para URGENTE */}
        {form.prioridade === "urgente" && (
          <div style={{ marginTop:12, background:"#FEF2F2", border:`1.5px solid #FCA5A5`,
            borderRadius:10, padding:"14px" }}>
            <label style={{ fontSize:12, fontWeight:700, color:"#DC2626", display:"block", marginBottom:6 }}>
              🔴 Justificativa para prioridade URGENTE <span style={{ color:"#DC2626" }}>*</span>
            </label>
            <textarea value={form.justificativa_urgente}
              onChange={e=>s("justificativa_urgente",e.target.value)}
              placeholder="Descreva o motivo pelo qual esta OS requer prioridade urgente (ex: parada de produção, prazo acadêmico crítico, equipamento inoperante...)"
              style={{ width:"100%", minHeight:80, padding:"9px 12px", borderRadius:8,
                border:"1.5px solid #FCA5A5", fontSize:13, fontFamily:"inherit",
                resize:"vertical", outline:"none", boxSizing:"border-box", lineHeight:1.6,
                background:"white" }}/>
          </div>
        )}
        <div style={{ marginTop:12 }}>
          <label style={{ fontSize:12, fontWeight:700, color:C.textSecondary, display:"block", marginBottom:5 }}>
            Descrição <span style={{ color:"#DC2626" }}>*</span>
          </label>
          <textarea value={form.descricao} onChange={e=>s("descricao",e.target.value)}
            placeholder="Descreva detalhadamente: material, dimensões, tolerâncias, acabamento, quantidade..."
            style={{ width:"100%", minHeight:110, padding:"10px 12px", borderRadius:9,
              border:`1.5px solid ${C.border}`, fontSize:14, fontFamily:"inherit",
              resize:"vertical", outline:"none", boxSizing:"border-box", lineHeight:1.6 }}/>
        </div>
      </div>

      <div style={{ marginBottom:24 }}>
        <SectionTitle>📎 Anexos</SectionTitle>
        <div onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
          onDrop={e=>{e.preventDefault();setDrag(false);handleFiles(e.dataTransfer.files);}}
          onClick={()=>fileRef.current.click()}
          style={{ border:`2px dashed ${drag?"#4F46E5":C.border}`, borderRadius:12,
            padding:"22px 20px", textAlign:"center", cursor:"pointer",
            background:drag?"#EEF2FF":"#F8FAFC" }}>
          <div style={{ fontSize:28, marginBottom:6 }}>📂</div>
          <div style={{ fontWeight:700, color:C.textPrimary, fontSize:13 }}>Arraste arquivos ou clique para selecionar</div>
          <div style={{ fontSize:12, color:C.textSecondary, marginTop:3 }}>.DWG, .SLDPRT, .STEP, .PDF, .DOCX, .XLSX e outros</div>
          <input ref={fileRef} type="file" multiple style={{ display:"none" }}
            accept=".dwg,.sldprt,.sldasm,.step,.stp,.pdf,.doc,.docx,.xls,.xlsx,.dxf,.igs,.stl"
            onChange={e=>handleFiles(e.target.files)}/>
        </div>
        {form.arquivos.length > 0 && (
          <div style={{ marginTop:10, display:"flex", flexWrap:"wrap", gap:8 }}>
            {form.arquivos.map((a,i)=>(
              <div key={i} style={{ display:"flex", alignItems:"center", gap:6, background:"#F1F5F9",
                border:"1px solid #E2E8F0", borderRadius:8, padding:"5px 10px", fontSize:12 }}>
                <FileIcon name={a.name}/><span>{a.name}</span>
                <button onClick={()=>s("arquivos",form.arquivos.filter((_,j)=>j!==i))}
                  style={{ background:"none", border:"none", cursor:"pointer", color:"#DC2626", fontSize:16, padding:0 }}>×</button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ display:"flex", justifyContent:"flex-end", gap:10 }}>
        {onCancel && <Btn outline color={C.textSecondary} onClick={onCancel}>Cancelar</Btn>}
        <Btn onClick={submit} disabled={loading} size="lg" color={C.indigo}>
          {loading ? "⏳ Enviando..." : osCorrecting ? "📤 Reenviar OS" : "📤 Enviar OS"}
        </Btn>
      </div>

      {/* Modal de confirmação do prazo */}
      {prazoModal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.6)", zIndex:2000,
          display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
          <div style={{ background:"white", borderRadius:16, padding:"32px 28px",
            maxWidth:420, width:"100%", boxShadow:"0 24px 80px rgba(0,0,0,0.25)", textAlign:"center" }}>
            <div style={{ fontSize:48, marginBottom:12 }}>⚠️</div>
            <div style={{ fontFamily:"'Syne',sans-serif", fontSize:20, fontWeight:800,
              color:C.textPrimary, marginBottom:16 }}>Atenção!</div>
            <div style={{ background:"#EEF2FF", borderRadius:12, padding:"18px",
              marginBottom:20, border:`1px solid ${C.indigo}30` }}>
              <div style={{ fontSize:13, color:C.textSecondary, marginBottom:6 }}>
                Prazo estimado de entrega
              </div>
              <div style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:800,
                color:C.indigo }}>
                {prazoModal.data}
              </div>
            </div>
            <p style={{ fontSize:13, color:C.textSecondary, lineHeight:1.6, marginBottom:24 }}>
              O prazo pode sofrer alterações conforme a demanda do laboratório.
            </p>
            <div style={{ display:"flex", gap:12, justifyContent:"center" }}>
              <Btn color="#DC2626" outline onClick={cancelarPrazo}>❌ Cancelar</Btn>
              <Btn color={C.indigo} onClick={confirmarPrazo}>✅ Prosseguir</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
// ═══════════════════════════════════════════════════════════════════════════════
function TelaUsuario({ lista, onCriar, onReenviar, loading, showAlerta }) {
  const [sub, setSub] = useState("nova"); // nova | acompanhar
  const [osEnviada, setOsEnviada] = useState(null); // agora guarda {id, ...dados} para o PDF
  const [osCorrecting, setOsCorrecting] = useState(null);

  // Acompanhar
  const [busca, setBusca] = useState("");
  const [resultados, setResultados] = useState([]);
  const [buscado, setBuscado] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const [detalhe, setDetalhe] = useState(null);

  const buscar = async () => {
    if (!busca.trim()) return;
    setBuscando(true);
    try {
      // Tenta buscar por chave primeiro, depois por email/telefone
      const chaveRegex = /^LAB-[A-Z0-9]{4}-\d{4}$/i;
      if (chaveRegex.test(busca.trim())) {
        const os = await fetchOSporChave(busca);
        setResultados(os ? [os] : []);
      } else {
        const lista = await fetchOSporSolicitante(busca);
        setResultados(lista);
      }
      setBuscado(true);
    } catch(e) { showAlerta("Erro na busca: "+e.message,"error"); }
    finally { setBuscando(false); }
  };

  const handleSubmit = async (form) => {
    try {
      if (osCorrecting) {
        await onReenviar(osCorrecting.id, form);
        setOsCorrecting(null);
        setSub("acompanhar");
      } else {
        const { id, chave } = await onCriar(form);
        // Monta objeto mínimo para o PDF imediato (sem histórico completo ainda)
        const dadosPDF = {
          id, status:"pendente", prioridade:form.prioridade,
          servico:form.servico, descricao:form.descricao, prazo:form.prazo,
          chaveAcesso: chave,
          executante:null, coordenador:null, observacaoCoord:"",
          dataCriacao:new Date().toISOString().split("T")[0],
          solicitante:{ nome:form.nome, email:form.email, setor:form.setor, telefone:form.telefone },
          historico:[{ data:new Date().toLocaleString("pt-BR"), acao:"OS criada pelo solicitante", usuario:form.nome, obs:"" }],
          anexos: form.arquivos ? form.arquivos.map(a=>({ nome:a.name, path:"", tamanho:a.size })) : [],
        };
        setOsEnviada({ id, chave, dados: dadosPDF });
      }
    } catch(e) { showAlerta("Erro: "+e.message,"error"); }
  };

  // Tela de confirmação pós-envio
  if (osEnviada) {
    return (
      <div style={{ maxWidth:560, margin:"60px auto", textAlign:"center" }}>
        <div style={{ fontSize:64, marginBottom:16 }}>🎉</div>
        <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:26, fontWeight:800, color:C.textPrimary, margin:"0 0 8px" }}>
          OS enviada com sucesso!
        </h2>
        <p style={{ color:C.textSecondary, marginBottom:24 }}>
          Guarde sua chave de acesso para acompanhar esta OS
        </p>

        {/* Chave em destaque */}
        <div style={{ background:"linear-gradient(135deg,#4F46E5,#7C3AED)", borderRadius:16,
          padding:"28px 32px", marginBottom:16 }}>
          <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.6)",
            textTransform:"uppercase", letterSpacing:2, marginBottom:8 }}>
            Chave de Acesso
          </div>
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:36, fontWeight:800,
            color:"white", letterSpacing:4 }}>
            {osEnviada.chave}
          </div>
          <div style={{ fontSize:11, color:"rgba(255,255,255,0.5)", marginTop:8 }}>
            {osEnviada.id}
          </div>
        </div>

        <div style={{ background:"#FEF3C7", border:"1px solid #FDE68A", borderRadius:10,
          padding:"12px 16px", marginBottom:16, fontSize:12, color:"#92400E", textAlign:"left" }}>
          <div style={{ fontWeight:700, marginBottom:6 }}></div>
          <div style={{ lineHeight:1.6 }}>
            Sua OS pode ser consultada por:<br/>
            <strong>🔑 Chave de acesso</strong> — {osEnviada.chave}<br/>
            <strong>✉️ E-mail</strong> — cadastrado no formulário<br/>
            <strong>📱 Telefone</strong> — cadastrado no formulário
          </div>
        </div>

        <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
          <Btn onClick={()=>{setOsEnviada(null); setSub("acompanhar"); setBusca(osEnviada.chave);}} outline color={C.indigo}>
            🔍 Acompanhar esta OS
          </Btn>
          {osEnviada.dados && (
            <Btn onClick={()=>gerarPDF(osEnviada.dados)} outline color="#059669">
              📄 Baixar PDF
            </Btn>
          )}
          <Btn onClick={()=>{setOsEnviada(null); setSub("nova");}} color={C.indigo}>
            ➕ Nova OS
          </Btn>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Sub-abas */}
      <div style={{ display:"flex", gap:4, marginBottom:28, background:"#E2E8F0",
        borderRadius:12, padding:4, width:"fit-content" }}>
        {[["nova","➕ Nova OS"],["acompanhar","🔍 Acompanhar OS"]].map(([id,label])=>(
          <button key={id} onClick={()=>setSub(id)} style={{
            background:sub===id?"white":"transparent",
            color:sub===id?C.textPrimary:C.textSecondary,
            border:"none", borderRadius:9, padding:"8px 20px",
            fontWeight:700, fontSize:13, cursor:"pointer",
            boxShadow:sub===id?"0 1px 6px rgba(0,0,0,0.1)":"none",
          }}>{label}</button>
        ))}
      </div>

      {sub === "nova" && (
        <div style={{ maxWidth:780 }}>
          <Card>
            <FormOS titulo="Nova Ordem de Serviço" onSubmit={handleSubmit}
              loading={loading} osCorrecting={osCorrecting}/>
          </Card>
        </div>
      )}

      {sub === "acompanhar" && (
        <div style={{ maxWidth:580 }}>
          <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:800, color:C.textPrimary, marginBottom:6 }}>
            Acompanhar OS
          </h2>
          <p style={{ color:C.textSecondary, fontSize:13, marginBottom:24 }}>
            Busque pelo seu e-mail, telefone ou chave de acesso
          </p>

          {/* Campo de busca */}
          <div style={{ background:C.indigoLight, border:`1.5px solid ${C.indigo}30`,
            borderRadius:14, padding:"24px", marginBottom:20 }}>
            <div style={{ fontSize:11, fontWeight:700, color:C.indigo, textTransform:"uppercase",
              letterSpacing:1, marginBottom:10 }}>Consultar minhas OS</div>
            <div style={{ display:"flex", gap:10 }}>
              <input value={busca} onChange={e=>setBusca(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&buscar()}
                placeholder="E-mail, telefone ou chave LAB-XXXX-2025"
                style={{ flex:1, padding:"12px 16px", borderRadius:10,
                  border:`2px solid ${C.indigo}40`, fontSize:14, outline:"none",
                  fontFamily:"inherit", background:"white" }}/>
              <Btn onClick={buscar} disabled={buscando} size="lg" color={C.indigo}>
                {buscando ? "..." : "Buscar"}
              </Btn>
            </div>
            <div style={{ display:"flex", gap:16, marginTop:10, fontSize:11, color:C.textSecondary }}>
              <span>✉️ seuemail@uni.br</span>
              <span>📱 31 9xxxx-xxxx</span>
              <span>🔑 LAB-XXXX-2025</span>
            </div>
          </div>

          {buscado && resultados.length === 0 && (
            <div style={{ textAlign:"center", padding:40, color:C.textSecondary }}>
              <div style={{ fontSize:40, marginBottom:10 }}>🔍</div>
              <p>Nenhuma OS encontrada para <strong>{busca}</strong></p>
              <p style={{ fontSize:12, marginTop:8 }}>Verifique se o e-mail ou telefone está igual ao cadastrado na OS</p>
            </div>
          )}

          {resultados.map(os=>(
            <Card key={os.id} style={{ marginBottom:12 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12 }}>
                <div style={{ flex:1, cursor:"pointer" }} onClick={()=>setDetalhe(os)}>
                  <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:8, flexWrap:"wrap" }}>
                    <span style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:16, color:C.textPrimary }}>{os.id}</span>
                    <Badge status={os.status}/><PrioBadge p={os.prioridade}/>
                  </div>
                  <div style={{ fontSize:13, color:C.textPrimary, marginBottom:6 }}>
                    <strong>{os.servico}</strong> — {os.descricao.slice(0,80)}{os.descricao.length>80?"...":""}
                  </div>
                  <div style={{ fontSize:12, color:C.textSecondary }}>📅 Prazo: {os.prazo}</div>
                  {os.executante && (
                    <div style={{ fontSize:12, color:"#7C3AED", fontWeight:700, marginTop:4 }}>👷 {os.executante}</div>
                  )}
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:6, alignItems:"flex-end" }}>
                  <Btn size="sm" outline color={C.indigo} onClick={e=>{e.stopPropagation();gerarPDF(os);}}>📄 PDF</Btn>
                  {os.status === "correcao" && (
                    <Btn color="#DC2626" size="sm" onClick={e=>{e.stopPropagation();setOsCorrecting(os);setSub("nova");}}>
                      ✏️ Corrigir
                    </Btn>
                  )}
                </div>
              </div>
              {/* Motivo de paralisação — visível para o solicitante */}
              {os.status === "paralisado" && os.historico.filter(h=>h.acao==="Execução paralisada").slice(-1)[0]?.obs && (
                <div style={{ marginTop:10, background:"#FFF7ED", border:"1px solid #FED7AA", borderRadius:8, padding:"8px 12px", fontSize:12, color:"#9A3412", display:"flex", gap:8 }}>
                  <span>⏸️</span>
                  <span><strong>Paralisado:</strong> {os.historico.filter(h=>h.acao==="Execução paralisada").slice(-1)[0].obs}</span>
                </div>
              )}
              {os.observacaoCoord && (
                <div style={{ marginTop:10, background:"#FEF3C7", borderRadius:8, padding:"8px 12px", fontSize:12, color:"#92400E" }}>
                  <strong>Motivo da devolução:</strong> {os.observacaoCoord}
                </div>
              )}
            </Card>
          ))}
        </div>
      )}

      {detalhe && <DetalheOS os={detalhe} onClose={()=>setDetalhe(null)} ocultarContato/>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// TELA DO GESTOR
// ═══════════════════════════════════════════════════════════════════════════════
function TelaGestor({ lista, onRecarregar, showAlerta, nomeGestor, usuarios, onRecarregarUsuarios }) {
  const [sub, setSub] = useState("painel");
  const [filtro, setFiltro] = useState("todos");
  const [anoFiltro, setAnoFiltro] = useState(new Date().getFullYear().toString());
  const [detalhe, setDetalhe] = useState(null);
  const [editando, setEditando] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const [motivoRecusa, setMotivoRecusa] = useState("");
  const [recusandoId, setRecusandoId] = useState(null);
  const [loadingAcao, setLoadingAcao] = useState(false);

  const acao = async (fn, msg, tipo="success") => {
    setLoadingAcao(true);
    try { await fn(); showAlerta(msg,tipo); await onRecarregar(); }
    catch(e) { showAlerta("Erro: "+e.message,"error"); }
    finally { setLoadingAcao(false); }
  };

  // Anos disponíveis baseados nas OS existentes
  const anosDisponiveis = ["todos", ...Array.from(new Set(lista.map(o => o.dataCriacao?.slice(0,4)).filter(Boolean))).sort().reverse()];

  // Filtra por ano primeiro, depois por status
  const listaPorAno = anoFiltro === "todos" ? lista : lista.filter(o => o.dataCriacao?.startsWith(anoFiltro));
  const filtradas = filtro === "todos" ? listaPorAno : listaPorAno.filter(o=>o.status===filtro);
  const hoje = new Date().toISOString().split("T")[0];

  const fila = listaPorAno.filter(o=>o.status==="aguardando").sort((a,b)=>{
    const ord={urgente:0,alta:1,normal:2};
    return ord[a.prioridade]-ord[b.prioridade]||a.prazo.localeCompare(b.prazo);
  });

  const isMobile = useIsMobile();

  return (
    <div>
      <div style={{ display:"flex", gap:4, marginBottom:20, background:"#E2E8F0",
        borderRadius:12, padding:4, width: isMobile ? "100%" : "fit-content", flexWrap:"wrap" }}>
        {[["painel","📊 Painel"],["lista","📋 OS"],["fila","⚡ Fila"],["equipe","👥 Equipe"]].map(([id,label])=>(
          <button key={id} onClick={()=>setSub(id)} style={{
            background:sub===id?"white":"transparent",
            color:sub===id?C.textPrimary:C.textSecondary,
            border:"none", borderRadius:9, padding: isMobile ? "8px 10px" : "8px 20px",
            fontWeight:700, fontSize: isMobile ? 12 : 13, cursor:"pointer", flex: isMobile ? 1 : "unset",
            boxShadow:sub===id?"0 1px 6px rgba(0,0,0,0.1)":"none",
          }}>{label}</button>
        ))}
      </div>

      {/* Filtro por ano */}
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20 }}>
        <span style={{ fontSize:12, fontWeight:700, color:C.textSecondary }}>📅 Ano:</span>
        <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
          {anosDisponiveis.map(ano=>(
            <button key={ano} onClick={()=>setAnoFiltro(ano)} style={{
              padding:"5px 14px", borderRadius:99, border:"1.5px solid",
              borderColor: anoFiltro===ano ? C.indigo : C.border,
              background: anoFiltro===ano ? C.indigo : "white",
              color: anoFiltro===ano ? "white" : C.textSecondary,
              fontWeight:700, fontSize:12, cursor:"pointer",
            }}>
              {ano === "todos" ? "Todos os anos" : ano}
            </button>
          ))}
        </div>
        {anoFiltro !== "todos" && (
          <span style={{ fontSize:12, color:C.textSecondary }}>
            &mdash; {listaPorAno.length} OS em {anoFiltro}
          </span>
        )}
      </div>
      
      {/* ── Painel ── */}
      {sub === "painel" && (
        <div>
          <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:800, color:C.textPrimary, marginBottom:20 }}>
            Visão Geral {anoFiltro !== "todos" && <span style={{ color:C.indigo }}>— {anoFiltro}</span>}
          </h2>
          <div style={{ display:"grid", gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(4,1fr)", gap:12, marginBottom:24 }}>
            {[
              { label:"Aguard. Aprovação", val:listaPorAno.filter(o=>o.status==="pendente").length,   color:"#D97706", bg:"#FEF3C7", icon:"⏳" },
              { label:"Na Fila",           val:listaPorAno.filter(o=>o.status==="aguardando").length,  color:"#2563EB", bg:"#DBEAFE", icon:"📋" },
              { label:"Em Execução",       val:listaPorAno.filter(o=>o.status==="execucao").length,    color:"#7C3AED", bg:"#EDE9FE", icon:"⚙️" },
              { label:"Finalizados",       val:listaPorAno.filter(o=>o.status==="finalizado").length,  color:"#059669", bg:"#D1FAE5", icon:"✅" },
            ].map((c,i)=>(
              <div key={i} style={{ background:c.bg, border:`1px solid ${c.color}35`, borderRadius:14, padding:"18px 20px" }}>
                <div style={{ fontSize:22, marginBottom:4 }}>{c.icon}</div>
                <div style={{ fontFamily:"'Syne',sans-serif", fontSize:32, fontWeight:800, color:c.color }}>{c.val}</div>
                <div style={{ fontSize:11, color:C.textPrimary, fontWeight:600 }}>{c.label}</div>
              </div>
            ))}
          </div>

          {/* Atrasadas */}
          {listaPorAno.filter(o=>o.prazo<hoje&&!["finalizado","cancelado"].includes(o.status)).length>0 && (
            <Card style={{ marginBottom:16, border:"1.5px solid #FECACA", background:"#FFF5F5" }}>
              <div style={{ fontWeight:800, color:"#DC2626", marginBottom:12 }}>
                ⚠️ OS com prazo vencido ({listaPorAno.filter(o=>o.prazo<hoje&&!["finalizado","cancelado"].includes(o.status)).length})
              </div>
              {listaPorAno.filter(o=>o.prazo<hoje&&!["finalizado","cancelado"].includes(o.status)).map(o=>(
                <div key={o.id} style={{ display:"flex", gap:10, alignItems:"center", padding:"6px 0",
                  borderTop:"1px solid #FECACA", fontSize:13 }}>
                  <strong>{o.id}</strong>— {o.servico} | Prazo: <span style={{color:"#DC2626",fontWeight:700}}>{o.prazo}</span>
                  <Badge status={o.status}/>
                </div>
              ))}
            </Card>
          )}

          {/* Tabela resumo */}
          <Card>
            <SectionTitle>Todas as OS ({listaPorAno.length})</SectionTitle>
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                <thead>
                  <tr style={{ background:"#F8FAFC" }}>
                    {["Nº OS","Solicitante","Serviço","Prazo","Prioridade","Status"].map(h=>(
                      <th key={h} style={{ padding:"10px 12px", textAlign:"left", fontWeight:700,
                        color:C.textSecondary, borderBottom:`1.5px solid ${C.border}`, whiteSpace:"nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {listaPorAno.map((os,i)=>(
                    <tr key={os.id} style={{ background:i%2===0?"white":"#FAFAFA", cursor:"pointer" }}
                      onClick={()=>setDetalhe(os)}>
                      <td style={{ padding:"10px 12px", borderBottom:`1px solid ${C.border}` }}>
                        <strong style={{ fontFamily:"'Syne',sans-serif" }}>{os.id}</strong>
                      </td>
                      <td style={{ padding:"10px 12px", borderBottom:`1px solid ${C.border}` }}>
                        {os.solicitante.nome}<br/>
                        <span style={{ color:C.textSecondary, fontSize:11 }}>{os.solicitante.setor}</span>
                      </td>
                      <td style={{ padding:"10px 12px", borderBottom:`1px solid ${C.border}` }}>{os.servico}</td>
                      <td style={{ padding:"10px 12px", borderBottom:`1px solid ${C.border}`,
                        color:os.prazo<hoje&&os.status!=="finalizado"?"#DC2626":C.textPrimary,
                        fontWeight:os.prazo<hoje?700:400 }}>
                        {os.prazo}{os.prazo<hoje&&os.status!=="finalizado"?" ⚠️":""}
                      </td>
                      <td style={{ padding:"10px 12px", borderBottom:`1px solid ${C.border}` }}><PrioBadge p={os.prioridade}/></td>
                      <td style={{ padding:"10px 12px", borderBottom:`1px solid ${C.border}` }}><Badge status={os.status}/></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      )}

      {/* ── Lista de OS com ações ── */}
      {sub === "lista" && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:800, color:C.textPrimary, margin:0 }}>
              Ordens de Serviço
            </h2>
          </div>

          {/* Filtros */}
          <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
            {["todos","pendente","correcao","aguardando","paralisado","execucao","finalizado"].map(s=>(
              <button key={s} onClick={()=>setFiltro(s)} style={{
                padding:"6px 14px", borderRadius:99, border:"1.5px solid",
                borderColor:filtro===s?C.indigo:C.border,
                background:filtro===s?C.indigo:"white",
                color:filtro===s?"white":C.textSecondary,
                fontWeight:600, fontSize:12, cursor:"pointer",
              }}>
                {s==="todos"?"Todos":STATUS_MAP[s]?.label}
              </button>
            ))}
          </div>

          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {filtradas.length===0 && (
              <div style={{ textAlign:"center", padding:50, color:C.textSecondary }}>Nenhuma OS.</div>
            )}
            {filtradas.map(os=>(
              <Card key={os.id} style={{
                borderLeft: os.prioridade==="urgente"?"4px solid #DC2626":
                            os.prioridade==="alta"?"4px solid #D97706":"1.5px solid #E2E8F0",
              }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12 }}>
                  <div style={{ flex:1, cursor:"pointer" }} onClick={()=>setDetalhe(os)}>
                    <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:8, flexWrap:"wrap" }}>
                      <span style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:15 }}>{os.id}</span>
                      <Badge status={os.status}/><PrioBadge p={os.prioridade}/>
                    </div>
                    <div style={{ fontSize:13, color:C.textPrimary, marginBottom:6 }}>
                      <strong>{os.servico}</strong> — {os.descricao.slice(0,90)}{os.descricao.length>90?"...":""}
                    </div>
                    <div style={{ display:"flex", gap:14, fontSize:12, color:C.textSecondary, flexWrap:"wrap" }}>
                      <span>👤 {os.solicitante.nome}</span>
                      <span>📚 {os.solicitante.setor}</span>
                      <span>📅 {os.prazo}</span>
                      {os.executante && <span style={{ color:"#7C3AED", fontWeight:700 }}>👷 {os.executante}</span>}
                    </div>
                  </div>

                  {/* Ações do gestor */}
                  <div style={{ display:"flex", flexDirection:"column", gap:6, alignItems:"flex-end", flexShrink:0 }}>
                    {os.status==="pendente" && <>
                      <Btn color="#059669" size="sm" onClick={()=>acao(()=>aceitarOS(os.id,nomeGestor),"OS aprovada ✅")}>✅ Aprovar</Btn>
                      <Btn color="#DC2626" size="sm" onClick={()=>{setRecusandoId(os.id);setMotivoRecusa("");}}>↩️ Recusar</Btn>
                    </>}
                    <Btn color={C.indigo} size="sm" outline onClick={()=>setEditando(os)}>✏️ Editar</Btn>
                    <Btn color="#DC2626" size="sm" outline onClick={()=>setConfirmDel(os.id)}>🗑️ Deletar</Btn>
                  </div>
                </div>

                {/* Inline recusa */}
                {recusandoId===os.id && (
                  <div style={{ marginTop:12, padding:14, background:"#FFF5F5",
                    borderRadius:10, border:"1px solid #FECACA" }}>
                    <label style={{ fontSize:12, fontWeight:700, color:"#DC2626" }}>Motivo da recusa *</label>
                    <textarea value={motivoRecusa} onChange={e=>setMotivoRecusa(e.target.value)}
                      placeholder="Descreva o que precisa ser corrigido..."
                      style={{ width:"100%", marginTop:6, padding:"8px 10px", borderRadius:8,
                        border:"1px solid #FECACA", fontSize:13, minHeight:60, resize:"vertical",
                        boxSizing:"border-box", fontFamily:"inherit" }}/>
                    <div style={{ display:"flex", gap:8, marginTop:8 }}>
                      <Btn color="#DC2626" size="sm"
                        onClick={()=>{ if(!motivoRecusa.trim())return;
                          acao(()=>devolverOS(os.id,motivoRecusa,nomeGestor),"OS devolvida ↩️","warn");
                          setRecusandoId(null);
                        }}>Confirmar</Btn>
                      <Btn color={C.textSecondary} size="sm" onClick={()=>setRecusandoId(null)}>Cancelar</Btn>
                    </div>
                  </div>
                )}
              </Card>
            ))}
          </div>
        </div>
      )}

      {/* ── Fila ── */}
      {sub === "fila" && (
        <div>
          <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:800, color:C.textPrimary, marginBottom:20 }}>
            Fila de Execução ({fila.length})
          </h2>
          {fila.length===0 && <div style={{ textAlign:"center", padding:50, color:C.textSecondary }}>Fila vazia.</div>}
          {fila.map((os,i)=>(
            <Card key={os.id} style={{ marginBottom:10 }}>
              <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                <div style={{ width:36, height:36, borderRadius:"50%", background:C.indigo, color:"white",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  fontFamily:"'Syne',sans-serif", fontSize:15, fontWeight:800, flexShrink:0 }}>
                  {i+1}
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, color:C.textPrimary, marginBottom:2 }}>
                    {os.id} — {os.servico}
                  </div>
                  <div style={{ fontSize:12, color:C.textSecondary }}>
                    👤 {os.solicitante.nome} | 📅 {os.prazo}
                  </div>
                </div>
                <PrioBadge p={os.prioridade}/>
              </div>
            </Card>
          ))}
        </div>
      )}

      {/* ── Equipe ── */}
      {sub === "equipe" && (
        <PainelEquipe
          usuarios={usuarios}
          onRecarregar={onRecarregarUsuarios}
          showAlerta={showAlerta}
          nomeGestor={nomeGestor}
        />
      )}

      {/* Modais */}
      {detalhe && <DetalheOS os={detalhe} onClose={()=>setDetalhe(null)}/>}

      {editando && (
        <Modal onClose={()=>setEditando(null)} width={760}>
          <FormOS titulo={`✏️ Editar ${editando.id}`} onCancel={()=>setEditando(null)}
            loading={loadingAcao}
            inicial={{
              nome:editando.solicitante.nome, email:editando.solicitante.email,
              setor:editando.solicitante.setor, telefone:editando.solicitante.telefone,
              descricao:editando.descricao, servico:editando.servico,
              prioridade:editando.prioridade, prazo:editando.prazo, arquivos:[],
            }}
            onSubmit={form=>acao(()=>editarOS(editando.id,form,nomeGestor),"OS atualizada ✅").then(()=>setEditando(null))}
          />
        </Modal>
      )}

      {confirmDel && (
        <Confirm
          msg={`Tem certeza que deseja excluir a OS ${confirmDel}? Esta ação não pode ser desfeita.`}
          onConfirm={()=>acao(()=>deletarOS(confirmDel),"OS excluída","warn").then(()=>setConfirmDel(null))}
          onCancel={()=>setConfirmDel(null)}
        />
      )}

    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// TELA DO EXECUTANTE
// ═══════════════════════════════════════════════════════════════════════════════
function TelaExecutante({ lista, onRecarregar, showAlerta, nomeExecutante }) {
  const [busca, setBusca] = useState("");
  const [filtro, setFiltro] = useState("todos");
  const [detalhe, setDetalhe] = useState(null);
  const [paralisando, setParalisando] = useState(null);
  const [motivoPar, setMotivoPar] = useState("");

  const acao = async (fn, msg, tipo="success") => {
    try { await fn(); showAlerta(msg,tipo); await onRecarregar(); setDetalhe(null); }
    catch(e) { showAlerta("Erro: "+e.message,"error"); }
  };

  const listaExec = lista.filter(o=>{
    // "Minhas": OS onde eu sou executante (qualquer status)
    const minhas = o.executante===nomeExecutante;
    // "Disponíveis": na fila sem executante atribuído, ou paralisadas minhas
    const disponivel = o.status==="aguardando";
    if(filtro==="minhas") return minhas;
    if(filtro==="disponiveis") return disponivel;
    // "Todas": minhas + disponíveis
    return minhas||disponivel;
  });

  const filtradas = busca
    ? listaExec.filter(o=>o.id.toLowerCase().includes(busca.toLowerCase())||o.servico.toLowerCase().includes(busca.toLowerCase()))
    : listaExec;

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:800, color:C.textPrimary }}>
          Olá, {nomeExecutante} 👷
        </div>
        <div style={{ color:C.textSecondary, fontSize:13 }}>Gerencie suas ordens de serviço</div>
      </div>

      {/* Stats rápidos */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12, marginBottom:24 }}>
        {[
          { label:"Minhas em execução", val:lista.filter(o=>o.executante===nomeExecutante&&o.status==="execucao").length, color:"#7C3AED", bg:"#EDE9FE", icon:"⚙️" },
          { label:"Disponíveis p/ iniciar", val:lista.filter(o=>o.status==="aguardando").length, color:"#2563EB", bg:"#DBEAFE", icon:"📋" },
          { label:"Finalizadas por mim", val:lista.filter(o=>o.executante===nomeExecutante&&o.status==="finalizado").length, color:"#059669", bg:"#D1FAE5", icon:"✅" },
        ].map((c,i)=>(
          <div key={i} style={{ background:c.bg, border:`1px solid ${c.color}30`, borderRadius:14, padding:"16px 18px" }}>
            <div style={{ fontSize:20 }}>{c.icon}</div>
            <div style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:800, color:c.color }}>{c.val}</div>
            <div style={{ fontSize:11, color:C.textPrimary, fontWeight:600 }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Busca e filtro */}
      <div style={{ display:"flex", gap:10, marginBottom:16, flexWrap:"wrap" }}>
        <input value={busca} onChange={e=>setBusca(e.target.value)}
          placeholder="Buscar por ID ou serviço..."
          style={{ flex:1, minWidth:200, padding:"9px 14px", borderRadius:9,
            border:`1.5px solid ${C.border}`, fontSize:13, outline:"none", fontFamily:"inherit" }}/>
        {[["todos","Todas"],["minhas","Minhas"],["disponiveis","Disponíveis"]].map(([id,label])=>(
          <button key={id} onClick={()=>setFiltro(id)} style={{
            padding:"8px 16px", borderRadius:99, border:"1.5px solid",
            borderColor:filtro===id?C.indigo:C.border,
            background:filtro===id?C.indigo:"white",
            color:filtro===id?"white":C.textSecondary,
            fontWeight:600, fontSize:12, cursor:"pointer",
          }}>{label}</button>
        ))}
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {filtradas.length===0 && (
          <div style={{ textAlign:"center", padding:50, color:C.textSecondary }}>Nenhuma OS encontrada.</div>
        )}
        {filtradas.map(os=>(
          <Card key={os.id} style={{
            borderLeft: os.executante===nomeExecutante&&os.status==="execucao"
              ? "4px solid #7C3AED"
              : os.status==="paralisado"?"4px solid #EA580C":"1.5px solid #E2E8F0",
          }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12 }}>
              <div style={{ flex:1, cursor:"pointer" }} onClick={()=>setDetalhe(os)}>
                <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:8, flexWrap:"wrap" }}>
                  <span style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:15 }}>{os.id}</span>
                  <Badge status={os.status}/><PrioBadge p={os.prioridade}/>
                </div>
                <div style={{ fontSize:14, fontWeight:600, color:C.textPrimary, marginBottom:4 }}>{os.servico}</div>
                <div style={{ fontSize:13, color:C.textSecondary, lineHeight:1.5 }}>
                  {os.descricao.slice(0,100)}{os.descricao.length>100?"...":""}
                </div>
                <div style={{ display:"flex", gap:12, marginTop:8, fontSize:12, color:C.textSecondary }}>
                  <span>👤 {os.solicitante.nome}</span>
                  <span>📅 {os.prazo}</span>
                  {os.executante && <span style={{ color:"#7C3AED", fontWeight:700 }}>👷 {os.executante}</span>}
                </div>
              </div>

              {/* Botões do executante */}
              <div style={{ display:"flex", flexDirection:"column", gap:6, alignItems:"flex-end", flexShrink:0 }}>
                {os.status==="aguardando" && (
                  <Btn color="#7C3AED" size="sm"
                    onClick={()=>acao(()=>iniciarOS(os.id,nomeExecutante),`⚙️ Você pegou a ${os.id}!`,"info")}>
                    ▶️ Pegar OS
                  </Btn>
                )}
                {os.status==="execucao" && os.executante===nomeExecutante && <>
                  <Btn color="#EA580C" size="sm" onClick={()=>{setParalisando(os.id);setMotivoPar("");}}>
                    ⏸️ Paralisar
                  </Btn>
                  <Btn color="#059669" size="sm"
                    onClick={()=>acao(()=>finalizarOS(os.id,nomeExecutante),"🎉 OS finalizada!")}>
                    🏁 Finalizar
                  </Btn>
                </>}
                {os.status==="paralisado" && os.executante===nomeExecutante && (
                  <Btn color="#7C3AED" size="sm"
                    onClick={()=>acao(()=>iniciarOS(os.id,nomeExecutante),"▶️ Execução retomada","info")}>
                    ▶️ Retomar
                  </Btn>
                )}
              </div>
            </div>

            {/* Motivo paralisação */}
            {paralisando===os.id && (
              <div style={{ marginTop:12, padding:14, background:"#FFF7ED",
                borderRadius:10, border:"1px solid #FED7AA" }}>
                <label style={{ fontSize:12, fontWeight:700, color:"#EA580C" }}>Motivo da paralisação *</label>
                <textarea value={motivoPar} onChange={e=>setMotivoPar(e.target.value)}
                  placeholder="Ex: aguardando material, manutenção da máquina..."
                  style={{ width:"100%", marginTop:6, padding:"8px 10px", borderRadius:8,
                    border:"1px solid #FED7AA", fontSize:13, minHeight:60,
                    resize:"vertical", boxSizing:"border-box", fontFamily:"inherit" }}/>
                <div style={{ display:"flex", gap:8, marginTop:8 }}>
                  <Btn color="#EA580C" size="sm"
                    onClick={()=>{
                      if(!motivoPar.trim())return;
                      acao(()=>paralisarOS(os.id,motivoPar,nomeExecutante),"⏸️ OS paralisada","warn");
                      setParalisando(null);
                    }}>Confirmar</Btn>
                  <Btn color={C.textSecondary} size="sm" onClick={()=>setParalisando(null)}>Cancelar</Btn>
                </div>
              </div>
            )}
          </Card>
        ))}
      </div>

      {detalhe && <DetalheOS os={detalhe} onClose={()=>setDetalhe(null)}/>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// PAINEL EQUIPE — Gestão de usuários do sistema
// ═══════════════════════════════════════════════════════════════════════════════
function PainelEquipe({ usuarios, onRecarregar, showAlerta, nomeGestor }) {
  const [editando, setEditando] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ nome:"", senha:"", email_notificacao:"", papel:"executante" });
  const [ferias, setFerias] = useState({ inicio:"", fim:"" });
  const [loadingFerias, setLoadingFerias] = useState(false);

  useEffect(() => {
    fetchConfiguracoes().then(config => {
      setFerias({
        inicio: config.ferias_inicio || "",
        fim: config.ferias_fim || "",
      });
    });
  }, []);

  const salvarFerias = async () => {
    setLoadingFerias(true);
    try {
      await salvarConfiguracao('ferias_inicio', ferias.inicio || null);
      await salvarConfiguracao('ferias_fim', ferias.fim || null);
      showAlerta("Período de recesso salvo ✅", "success");
    } catch(e) {
      showAlerta("Erro ao salvar: "+e.message, "error");
    } finally {
      setLoadingFerias(false);
    }
  };

  const limparFerias = async () => {
    setLoadingFerias(true);
    try {
      await salvarConfiguracao('ferias_inicio', null);
      await salvarConfiguracao('ferias_fim', null);
      setFerias({ inicio:"", fim:"" });
      showAlerta("Período de recesso removido.", "warn");
    } catch(e) {
      showAlerta("Erro: "+e.message, "error");
    } finally {
      setLoadingFerias(false);
    }
  };

  const abrirEditar = (u) => {
    // Não carrega senha — usuário deve digitar nova senha se quiser alterar
    setForm({ nome:u.nome, senha:"", email_notificacao:u.email_notificacao||"", papel:u.papel });
    setEditando(u);
  };

  const abrirNovo = (papel) => {
    setForm({ nome:"", senha:"", email_notificacao:"", papel });
    setEditando({ papel }); // sem id = novo
  };

  const salvar = async () => {
    if (!form.nome.trim()) {
      showAlerta("Nome é obrigatório.", "warn"); return;
    }
    // Para novo usuário, senha é obrigatória
    if (!editando.id && !form.senha.trim()) {
      showAlerta("Senha é obrigatória para novo usuário.", "warn"); return;
    }
    setLoading(true);
    try {
      await salvarUsuario({ ...form, id: editando.id });
      showAlerta("Usuário salvo com sucesso ✅", "success");
      await onRecarregar();
      setEditando(null);
    } catch(e) { showAlerta("Erro: "+e.message, "error"); }
    finally { setLoading(false); }
  };

  const deletar = async (id) => {
    setLoading(true);
    try {
      await deletarUsuario(id);
      showAlerta("Usuário removido.", "warn");
      await onRecarregar();
      setConfirmDel(null);
    } catch(e) { showAlerta("Erro: "+e.message, "error"); }
    finally { setLoading(false); }
  };

  const gestores    = usuarios.filter(u => u.papel === "gestor");
  const executantes = usuarios.filter(u => u.papel === "executante");

  const CardUsuario = ({ u }) => (
    <Card style={{ marginBottom:8 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:12 }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <div style={{ width:40, height:40, borderRadius:"50%",
            background: u.papel==="gestor" ? "#EDE9FE" : "#DBEAFE",
            display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, flexShrink:0 }}>
            {u.papel==="gestor" ? "🏛️" : "⚙️"}
          </div>
          <div>
            <div style={{ fontWeight:700, fontSize:14, color:C.textPrimary }}>{u.nome}</div>
            <div style={{ fontSize:11, color:C.textSecondary, marginTop:2 }}>
              {u.email_notificacao || "Sem e-mail cadastrado"}
            </div>
          </div>
        </div>
        <div style={{ display:"flex", gap:6, alignItems:"center" }}>
          <span style={{ fontSize:11, color:C.textSecondary, fontFamily:"monospace",
            background:"#F1F5F9", padding:"2px 8px", borderRadius:6 }}>
            ••••••••
          </span>
          <Btn size="sm" outline color={C.indigo} onClick={()=>abrirEditar(u)}>✏️ Editar</Btn>
          {u.nome !== nomeGestor && (
            <Btn size="sm" outline color="#DC2626" onClick={()=>setConfirmDel(u)}>🗑️</Btn>
          )}
        </div>
      </div>
    </Card>
  );

  return (
    <div style={{ maxWidth:680 }}>
      <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:800,
        color:C.textPrimary, marginBottom:6 }}>Equipe do Laboratório</h2>
      <p style={{ color:C.textSecondary, fontSize:13, marginBottom:24 }}>
        Gerencie nomes, senhas e e-mails de notificação da equipe
      </p>

      {/* Período de recesso/férias */}
      <Card style={{ marginBottom:28, background:"#F0FDF4", border:"1.5px solid #86EFAC" }}>
        <SectionTitle>🏖️ Período de Recesso / Férias</SectionTitle>
        <p style={{ fontSize:12, color:C.textSecondary, marginBottom:14, lineHeight:1.6 }}>
          Durante o recesso o prazo mínimo passa de <strong>30</strong> para <strong>60 dias úteis</strong>.
          Deixe em branco se não houver recesso programado.
        </p>
        <div style={{ display:"flex", gap:12, flexWrap:"wrap", alignItems:"flex-end" }}>
          <Input label="Início do recesso" value={ferias.inicio}
            onChange={v=>setFerias(f=>({...f,inicio:v}))} type="date"/>
          <Input label="Fim do recesso" value={ferias.fim}
            onChange={v=>setFerias(f=>({...f,fim:v}))} type="date"/>
          <div style={{ display:"flex", gap:8 }}>
            <Btn color="#059669" onClick={salvarFerias} disabled={loadingFerias}>
              {loadingFerias ? "Salvando..." : "💾 Salvar"}
            </Btn>
            {(ferias.inicio || ferias.fim) && (
              <Btn outline color="#DC2626" onClick={limparFerias} disabled={loadingFerias}>
                🗑️ Limpar
              </Btn>
            )}
          </div>
        </div>
        {ferias.inicio && ferias.fim && (
          <div style={{ marginTop:12, fontSize:12, color:"#15803D", fontWeight:600 }}>
            ✅ Recesso configurado: {new Date(ferias.inicio+'T12:00:00').toLocaleDateString('pt-BR')} até {new Date(ferias.fim+'T12:00:00').toLocaleDateString('pt-BR')}
          </div>
        )}
      </Card>

      {/* Gestores */}
      <div style={{ marginBottom:24 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
          <SectionTitle>🏛️ Gestores ({gestores.length})</SectionTitle>
          <Btn size="sm" color={C.indigo} onClick={()=>abrirNovo("gestor")}>+ Adicionar</Btn>
        </div>
        {gestores.length===0 && <div style={{ fontSize:13, color:C.textSecondary }}>Nenhum gestor cadastrado.</div>}
        {gestores.map(u => <CardUsuario key={u.id} u={u}/>)}
      </div>

      {/* Executantes */}
      <div>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
          <SectionTitle>⚙️ Executantes ({executantes.length})</SectionTitle>
          <Btn size="sm" color={C.indigo} onClick={()=>abrirNovo("executante")}>+ Adicionar</Btn>
        </div>
        {executantes.length===0 && <div style={{ fontSize:13, color:C.textSecondary }}>Nenhum executante cadastrado.</div>}
        {executantes.map(u => <CardUsuario key={u.id} u={u}/>)}
      </div>

      {/* Modal editar / novo */}
      {editando && (
        <Modal onClose={()=>setEditando(null)} width={460}>
          <div style={{ padding:"28px" }}>
            <div style={{ fontFamily:"'Syne',sans-serif", fontSize:18, fontWeight:800,
              color:C.textPrimary, marginBottom:20 }}>
              {editando.id ? `✏️ Editar — ${editando.nome}` : `➕ Novo ${form.papel === "gestor" ? "Gestor" : "Executante"}`}
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <Input label="Nome completo" value={form.nome}
                onChange={v=>setForm(f=>({...f, nome:v}))} placeholder="Ex: Téc. João Silva" required/>
              <Input label={editando?.id ? "Nova senha (deixe em branco para manter)" : "Senha de acesso"} 
                value={form.senha}
                onChange={v=>setForm(f=>({...f, senha:v}))} 
                placeholder={editando?.id ? "Digite apenas para alterar" : "Mínimo 6 caracteres"}
                required={!editando?.id}/>
              <Input label="E-mail para notificações" value={form.email_notificacao}
                onChange={v=>setForm(f=>({...f, email_notificacao:v}))}
                placeholder="nome@universidade.edu.br" type="email"/>
              <div style={{ background:"#F8FAFC", borderRadius:8, padding:"10px 14px", fontSize:12, color:C.textSecondary }}>
                ℹ️ O e-mail é usado para notificar novas OS aprovadas (executante) ou aguardando aprovação (gestor).
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <Btn color={C.indigo} onClick={salvar} disabled={loading}>
                {loading ? "Salvando..." : "💾 Salvar"}
              </Btn>
              <Btn outline color={C.textSecondary} onClick={()=>setEditando(null)}>Cancelar</Btn>
            </div>
          </div>
        </Modal>
      )}

      {/* Confirmação exclusão */}
      {confirmDel && (
        <Confirm
          msg={`Remover ${confirmDel.nome} do sistema? Esta ação não pode ser desfeita.`}
          onConfirm={()=>deletar(confirmDel.id)}
          onCancel={()=>setConfirmDel(null)}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// LOGIN
// ═══════════════════════════════════════════════════════════════════════════════
function LoginRestritoModal({ papel, onLogin, onClose }) {
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);

  const tentar = async () => {
    if (!senha.trim()) return;
    setCarregando(true);
    setErro("");
    try {
      const { verificarLogin } = await import("./api");
      const u = await verificarLogin(senha, papel);
      if (u) { onLogin(u); }
      else { setErro("Senha incorreta."); }
    } catch(e) {
      setErro("Erro ao verificar senha.");
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Modal onClose={onClose} width={400}>
      <div style={{ padding:"36px 32px", textAlign:"center" }}>
        <div style={{ fontSize:48, marginBottom:12 }}>🔐</div>
        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:20, fontWeight:800, marginBottom:4 }}>
          {papel==="gestor"?"Acesso Gestor":"Acesso Executante"}
        </div>
        <p style={{ color:C.textSecondary, fontSize:13, marginBottom:24, lineHeight:1.6 }}>
          {papel==="gestor"
            ? "Apenas gestores autorizados."
            : "Informe a senha do seu perfil de executante."}
        </p>
        <input type="password" value={senha} onChange={e=>{setSenha(e.target.value);setErro("");}}
          onKeyDown={e=>e.key==="Enter"&&tentar()} placeholder="Senha"
          style={{ width:"100%", padding:"12px 14px", borderRadius:10,
            border:`1.5px solid ${erro?"#DC2626":C.border}`,
            fontSize:15, outline:"none", boxSizing:"border-box", marginBottom:8, fontFamily:"inherit" }}/>
        {erro && <div style={{ color:"#DC2626", fontSize:12, marginBottom:10 }}>{erro}</div>}
        <Btn onClick={tentar} disabled={carregando} size="lg" color={C.indigo}>
          {carregando ? "Verificando..." : "Entrar"}
        </Btn>
      </div>
    </Modal>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// APP PRINCIPAL
// ═══════════════════════════════════════════════════════════════════════════════
export default function App() {
  const [perfil, setPerfil] = useState("usuario");
  const [usuario, setUsuario] = useState(null);
  const [loginModal, setLoginModal] = useState(null);
  const [lista, setLista] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [loadingAcao, setLoadingAcao] = useState(false);
  const [toast, setToast] = useState(null);

  const showAlerta = useCallback((msg, tipo="info") => {
    setToast({ msg, tipo });
    setTimeout(()=>setToast(null), 5000);
  }, []);

  const recarregar = useCallback(async () => {
    try {
      const data = await fetchTodasOS();
      setLista(data);
    } catch(e) {
      showAlerta("Erro ao carregar OS. Verifique o Supabase.", "error");
    } finally {
      setCarregando(false);
    }
  }, [showAlerta]);

  const recarregarUsuarios = useCallback(async () => {
    try {
      const data = await fetchUsuarios();
      setUsuarios(data);
    } catch(e) {
      console.warn("Erro ao carregar usuários:", e.message);
    }
  }, []);

  useEffect(()=>{ recarregar(); recarregarUsuarios(); }, [recarregar, recarregarUsuarios]);

  const handleCriar = async (form) => {
    setLoadingAcao(true);
    try {
      const resultado = await criarOS(form);
      await recarregar();
      return resultado; // { id, chave }
    } catch(e) {
      showAlerta("Erro ao criar OS: "+e.message, "error");
      throw e;
    } finally {
      setLoadingAcao(false);
    }
  };

  const handleReenviar = async (osId, form) => {
    setLoadingAcao(true);
    try {
      await reenviarOS(osId, form);
      showAlerta(`OS ${osId} reenviada!`, "success");
      await recarregar();
    } catch(e) {
      showAlerta("Erro: "+e.message, "error");
      throw e;
    } finally {
      setLoadingAcao(false);
    }
  };

  const trocarPerfil = (novoPerfil) => {
    if (novoPerfil === "usuario") {
      setPerfil("usuario");
      setUsuario(null);
    } else {
      setLoginModal(novoPerfil);
    }
  };

  const handleLogin = (u) => {
    setUsuario(u);
    setPerfil(u.papel);
    setLoginModal(null);
    showAlerta(`Bem-vindo, ${u.nome}!`, "success");
  };

  const logout = () => {
    setPerfil("usuario");
    setUsuario(null);
    showAlerta("Sessão encerrada.", "info");
  };

  const pendentes = lista.filter(o=>o.status==="pendente").length;
  const isMobile = useIsMobile();

  const ABAS = [
    { id:"usuario",    label:"Solicitante", icon:"👤" },
    { id:"gestor",     label:"Gestor",      icon:"🏛️", restrito:true },
    { id:"executante", label:"Executante",  icon:"⚙️", restrito:true },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700&display=swap');
        * { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'DM Sans',sans-serif; background:${C.bg}; color:${C.textPrimary}; }
        input:focus,select:focus,textarea:focus {
          border-color:${C.indigo}!important;
          box-shadow:0 0 0 3px rgba(79,70,229,.12)!important;
          outline:none!important;
        }
        @keyframes slideIn { from{opacity:0;transform:translateX(24px)} to{opacity:1;transform:translateX(0)} }
        @keyframes spin { to{transform:rotate(360deg)} }
      `}</style>

      {toast && <Toast msg={toast.msg} tipo={toast.tipo} onClose={()=>setToast(null)}/>}
      {loginModal && (
        <LoginRestritoModal
          papel={loginModal}
          onLogin={handleLogin}
          onClose={()=>setLoginModal(null)}
        />
      )}

      {/* Header */}
      <header style={{ background:"#0F172A", position:"sticky", top:0, zIndex:100,
        boxShadow:"0 1px 0 rgba(255,255,255,0.06)" }}>
        <div style={{ maxWidth:1140, margin:"0 auto", padding:"0 16px",
          display:"flex", alignItems:"center", gap:12, height: isMobile ? 56 : 72 }}>

          {/* Logo + identidade */}
          <div style={{ display:"flex", alignItems:"center", gap:10, flexShrink:0 }}>
            <img src="/logo-unifei.png" alt="UNIFEI"
              style={{ height: isMobile ? 36 : 52, width:"auto", objectFit:"contain" }}/>
            <div style={{ borderLeft:"1px solid #1E293B", paddingLeft:10 }}>
              <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, color:"white",
                fontSize: isMobile ? 14 : 18, letterSpacing:-0.3, lineHeight:1.1 }}>LabOS</div>
              {!isMobile && <>
                <div style={{ fontSize:9, color:"#64748B", letterSpacing:0.8, textTransform:"uppercase", marginTop:3 }}>
                  Laboratório de Usinagem
                </div>
                <div style={{ fontSize:8.5, color:"#4B5563", letterSpacing:0.3, marginTop:2 }}>
                  Instituto de Engenharias Integradas · IEI
                </div>
                <div style={{ fontSize:8.5, color:"#374151", letterSpacing:0.3, marginTop:1 }}>
                  UNIFEI · Campus Itabira · MG
                </div>
              </>}
            </div>
          </div>

          <nav style={{ flex:1, display:"flex", justifyContent:"center", gap:2 }}>
            {ABAS.map(a=>(
              <button key={a.id} onClick={()=>trocarPerfil(a.id)} style={{
                background: perfil===a.id?"#4F46E5":"transparent",
                color: perfil===a.id?"white":"#94A3B8",
                border:"none", borderRadius:9, padding: isMobile ? "7px 12px" : "7px 18px",
                fontWeight:700, fontSize: isMobile ? 18 : 13, cursor:"pointer", position:"relative",
                transition:"all .15s", fontFamily:"'DM Sans',sans-serif",
                display:"flex", alignItems:"center", gap:6,
              }}>
                {a.icon} {!isMobile && a.label}
                {a.id==="gestor" && pendentes>0 && perfil!=="gestor" && (
                  <span style={{ background:"#DC2626", color:"white", borderRadius:99,
                    padding:"1px 6px", fontSize:9, fontWeight:800 }}>{pendentes}</span>
                )}
                {a.restrito && perfil!==a.id && !isMobile && (
                  <span style={{ fontSize:9, color:"#475569" }}>🔒</span>
                )}
              </button>
            ))}
          </nav>

          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            {usuario && (
              <>
                <div style={{ textAlign:"right" }}>
                  <div style={{ fontFamily:"'Syne',sans-serif", fontSize:14, fontWeight:800, color:"white" }}>
                    {usuario.nome}
                  </div>
                  <div style={{ fontSize:10, color:"#64748B", textTransform:"uppercase", letterSpacing:1 }}>
                    {usuario.papel}
                  </div>
                </div>
                <button onClick={logout} style={{ background:"#1E293B", border:"none",
                  borderRadius:8, padding:"6px 12px", color:"#94A3B8",
                  fontSize:12, cursor:"pointer", fontWeight:600 }}>Sair</button>
              </>
            )}
          </div>
        </div>
      </header>

      {/* Conteúdo */}
      <main style={{ maxWidth:1140, margin:"0 auto", padding: isMobile ? "16px 12px" : "32px 24px" }}>
        {carregando && perfil !== "usuario" ? <Spinner/> : (
          <>
            {perfil==="usuario" && (
              <TelaUsuario lista={lista} onCriar={handleCriar}
                onReenviar={handleReenviar} loading={loadingAcao} showAlerta={showAlerta}/>
            )}
            {perfil==="gestor" && usuario && (
              <TelaGestor lista={lista} onRecarregar={recarregar}
                showAlerta={showAlerta} nomeGestor={usuario.nome}
                usuarios={usuarios} onRecarregarUsuarios={recarregarUsuarios}/>
            )}
            {perfil==="executante" && usuario && (
              <TelaExecutante lista={lista} onRecarregar={recarregar}
                showAlerta={showAlerta} nomeExecutante={usuario.nome}/>
            )}
          </>
        )}
      </main>

      {/* Rodapé */}
      <footer style={{ borderTop:`1px solid ${C.border}`, marginTop:40, padding:"16px 24px",
        textAlign:"center" }}>
        <div style={{ fontSize:11, color:C.textSecondary }}>
          Desenvolvido por <strong style={{ color:C.textPrimary }}>Nayara Reis</strong> — UNIFEI 2026
        </div>
      </footer>
    </>
  );
}
